import { nanoid } from 'nanoid'

export default {
  props: {
    id: {
      type: String,
      default: nanoid(10)
    },
    placeholder: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    help: {
      type: String,
      default: null
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    v: {
      type: Object,
      default: () => ({})
    },
    showEditButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isOnEditMode () {
      return !!this.$route?.params?.id
    },
    isRequired () {
      return this.v.required !== undefined
    }
  }
}
